/** @userstory US-NOTIF-02, US-NOTIF-03 */
import apiClient from './apiClient';

// ============================================
// Types
// ============================================

/** Read model for an in-app notification returned to the recipient. */
export interface Notification {
	id: string;
	type: string;
	data: Record<string, string>;
	createdAt: string;
	readAt: string | null;
	isRead: boolean;
}

// ============================================
// Service
// ============================================

const notificationsService = {
	/** Returns the caller's notifications, newest first. */
	getMyNotifications: async (): Promise<Notification[]> => {
		const { data } = await apiClient.get<Notification[]>('/api/notifications');
		return data;
	},

	/** Returns the caller's unread notification count. */
	getUnreadCount: async (): Promise<number> => {
		const { data } = await apiClient.get<{ count: number }>('/api/notifications/unread-count');
		return data.count ?? 0;
	},

	/** Marks one of the caller's notifications as read. */
	markAsRead: async (id: string): Promise<void> => {
		await apiClient.post(`/api/notifications/${id}/read`);
	},
};

export default notificationsService;
